import { Injectable } from "@angular/core";
import { CommonService } from "../services/common.service";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    private isLoggingOut = false;

    constructor(private commonService: CommonService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {

                if (error.status === 401 && !this.isLoggingOut) {
                    this.isLoggingOut = true;
                    this.commonService.logOut();
                }

                return throwError(() => error);
            })
        );
    }
}
